/**
 * Clear all client-accessible cookies (non-HttpOnly).
 * HttpOnly cookies can only be expired by the server (e.g. on logout API).
 */
export const clearAllCookies = () => {
  try {
    if (typeof document === 'undefined' || !document.cookie) return
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const name = cookies[i].split('=')[0].trim()
      if (name) {
        document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0`
        document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; SameSite=Strict`
      }
    }
  } catch (error) {
    console.warn('Failed to clear cookies:', error)
  }
}
